import { render, staticRenderFns } from "./TelInputComponent.vue?vue&type=template&id=19f1e9f0&scoped=true"
import script from "./TelInputComponent.vue?vue&type=script&lang=js"
export * from "./TelInputComponent.vue?vue&type=script&lang=js"
import style0 from "./TelInputComponent.vue?vue&type=style&index=0&id=19f1e9f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f1e9f0",
  null
  
)

export default component.exports